import { createFileRoute } from "@tanstack/react-router";
import { CompanyLinkPage } from "../screens/company-links/index.ts";

/** `/company/delete#<token>`: the link in the mail that confirms deleting a company. */
export const Route = createFileRoute("/company/delete")({
  component: () => <CompanyLinkPage kind="delete" />,
});
